import { createContext } from "react";

export interface User {
  id: string;
  email: string;
  name: string | null;
  isAdmin: boolean;
  isProvisionedClient: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Session {
  id: string;
  userId: string;
  expiresAt: Date;
}

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  signInWithMagicLink: (
    email: string,
    callbackURL?: string
  ) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
